import { type ComponentProps } from 'react'

import { type TabPills } from '@components/common'

export const CATEGORIES = [
  { value: 'recommendations' as const, label: 'Recommended' },
  { value: 'favorites' as const, label: 'Favorites' },
] satisfies ComponentProps<typeof TabPills>['options']

export type Category = (typeof CATEGORIES)[number]['value']
